// styles/errorStyles.js
export const errorContainer = (theme) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "30vh",
  gap: 2,
});

export const errorTitle = {
  color: "error.main",
  textAlign: "center",
};
